import "../AverageBasedCalculatorModal/AverageBasedCalculatorModal";
import i18n from "../../../locale/i18n";
import { useInstrument } from "../../../hooks/useInstruments";
import { useTemplateSetting } from "../../../hooks/useCompanySettings";
import { TOOL_TEMPLATE } from "../../../constant/common";

const isIFrame = window.self !== window.top;

const AverageBasedCalculatorButton = () => {
  const [{ selectedInstrument }] = useInstrument();
  const template = useTemplateSetting();
  return (

    <button
      className="average-based-calculator-button"
      onClick={() => {
        const component = window.euroland?.components.AverageBasedCalculatorModal({ selectedInstrument });

        if (!component) {
          console.error("euroland component not available");
          return;
        }

        const integrationLayoutPosition =
          window.xprops?.layout?.middle || "#middleLayout";

        if (isIFrame) {
          component.renderTo(window.parent, integrationLayoutPosition);
        } else {
          let middle = document.getElementById("middleLayout");
          if (!middle) {
            middle = document.createElement("div");
            middle.id = "middleLayout";
            document.body.appendChild(middle);
          }
          component.renderTo(window.parent, integrationLayoutPosition);
        }
      }}
    >
      {template === TOOL_TEMPLATE.quadrata && <span className="fs-caculator"></span>}
      <span>{i18n.translate("averageBasedCalculator")}</span>
    </button>

  );
};

export default AverageBasedCalculatorButton;
